//@flow
import { compose, lifecycle } from 'recompose'
import { connect } from 'react-redux'

import type { AppState } from 'quick-quote/reducers'
import { getCurrentApp } from 'e-submission/apps/selectors'
import { Radio } from 'common-components/radio-group'
import { ButtonComponent } from 'common-components/button'
import SendLinkRoomIdNotExist from 'e-submission/containers/Dialog/SendLinkRoomIdNotExist'
import ResumeRMS from 'e-submission/containers/Dialog/ResumeRMS'

import {
  closeNewRemoteSellingPreviewInfoModal,
  disableAppmanRemoteSelling,
  disabledEkycOnDevice,
  enableAppmanRemoteSelling,
  enableEkycOnDevice,
  setAppValue,
  openNative,
  closeSendingLinkModalRemoteSelling,
  closeRemoteSellingResumeModal,
  uncheckAppmanRemoteSelling,
  checkAppmanRemoteSelling,
} from 'e-submission/apps/actions'
import { findParentNodeTarget } from 'e-submission/components/Card/EkycDocument'
import {
  getRemoteSellingState,
  isOnDeviceEKYC,
  insurerDoesEkyc,
  payerDoesEkyc,
  getCitizenId,
} from 'e-submission/domain/data-model/form/selectors'
import { enterRemoteSelling } from 'core/actions'
import NewRemoteSellingPreviewInfo from 'e-submission/containers/Dialog/NewRemoteSellingPreviewInfo'
import React from 'react'
import { IsRealDevice } from 'e-submission/utils'
import IdentifyEkycResponding from 'e-submission/containers/Dialog/IdentifyEkycResponding'
import NewRemoteSellingWarning from 'e-submission/containers/Dialog/NewRemoteSellingWarning'

function faceToFaceRadioOptions(shouldShowF2fOption, checkEkycOnDevice, uncheckEkycOnDevice, isEkycOnDevice) {
  if (shouldShowF2fOption) {
    return (
      <>
        <div style={{ paddingLeft: '5%', paddingBottom: '2%', paddingTop: '2%' }}>
          {IsRealDevice && (
            <Radio
              option={{ text: 'ยืนยันตัวตน (eKYC) ผ่านระบบ AdvisorZone', value: true }}
              subOptions={{}}
              active={isEkycOnDevice}
              onClick={checkEkycOnDevice}
            />
          )}
          <Radio
            option={{ text: 'ยืนยันตัวตน (eKYC) ด้วยตนเอง ระบบจะส่ง link ผ่านช่องทาง Email หรือ SMS', value: true }}
            subOptions={{}}
            active={!isEkycOnDevice}
            onClick={uncheckEkycOnDevice}
          />
        </div>
      </>
    )
  }

  return null
}

export function checkShowingF2fOption(
  selectedRemoteSelling,
  isPayerNeedToBeEkycDone,
  isInsuredNeedToBeEkycDone,
  payerCitizenId
) {
  if (
    !selectedRemoteSelling &&
    ((isInsuredNeedToBeEkycDone && !payerCitizenId) ||
      (isInsuredNeedToBeEkycDone && isPayerNeedToBeEkycDone) ||
      isPayerNeedToBeEkycDone)
  )
    return true

  return false
}

function onClickEnterIntoRemoteSellingButton(enterRemoteSelling) {
  return function() {
    enterRemoteSelling()
  }
}

class EkycSellingChannel extends React.Component {
  constructor(props) {
    super(props)
    this.refRootComponent = null
    this.setRootComponentRef = (element) => {
      this.refRootComponent = element
    }
    this.state = {
      isSkipEkyc: false,
    }
  }

  componentDidMount() {
    const formEngineDom = findParentNodeTarget(this.refRootComponent)
    if (formEngineDom && IsRealDevice) formEngineDom.style.maxWidth = '900px'
  }

  componentWillUnmount() {
    const formEngineDom = findParentNodeTarget(this.refRootComponent)
    if (formEngineDom && IsRealDevice) formEngineDom.style.maxWidth = '680px'
  }

  render() {
    const {
      selectedRemoteSelling,
      enableEkycOnDevice,
      checkAppmanRemoteSelling,
      uncheckAppmanRemoteSelling,
      checkEkycOnDevice,
      uncheckEkycOnDevice,
      enterRemoteSelling,
      isOpenNewRemoteSellingPreviewInfoModal,
      closeNewRemoteSellingPreviewInfoModal,
      isModalCreatingRemoteSellingOpen,
      creatingRemoteSellingCaseStatus,
      closeCreatingRemoteSellingCaseModal,
      caseId,
      openNative,
      shouldShowF2fOption,
      isInCall,
    } = this.props

    return (
      <>
        <NewRemoteSellingWarning />
        <NewRemoteSellingPreviewInfo
          isOpen={isOpenNewRemoteSellingPreviewInfoModal}
          onExit={closeNewRemoteSellingPreviewInfoModal}
        />
        <SendLinkRoomIdNotExist />
        <ResumeRMS />

        <div ref={this.setRootComponentRef} style={{ marginBottom: '2rem' }}>
          <Radio
            isHeading
            disabled={isInCall}
            option={{ text: 'แบบเข้าพบลูกค้า (Face to face)', value: false }}
            subOptions={{}}
            active={!selectedRemoteSelling}
            onClick={uncheckAppmanRemoteSelling}
          />
          {faceToFaceRadioOptions(shouldShowF2fOption, checkEkycOnDevice, uncheckEkycOnDevice, enableEkycOnDevice)}
          {IsRealDevice && (
            <Radio
              isHeading
              disabled={isInCall}
              option={{ text: 'แบบลูกค้าไม่สะดวกให้เข้าพบ (Remote Selling)', value: true }}
              subOptions={{}}
              active={selectedRemoteSelling}
              onClick={checkAppmanRemoteSelling}
            />
          )}

          <IdentifyEkycResponding
            isDuplicate={false}
            insuredOrPayer={''}
            identifyEkycRespond={creatingRemoteSellingCaseStatus}
            isReuseCase={false}
            isOpen={isModalCreatingRemoteSellingOpen}
            onExit={() => {
              closeCreatingRemoteSellingCaseModal()
            }}
            onSubmit={() => {
              closeCreatingRemoteSellingCaseModal()
              if (caseId) {
                openNative(caseId, 'ekyc')
              }
            }}
            isRemoteSellingRespond
          />
        </div>
        {selectedRemoteSelling && IsRealDevice && (
          <ButtonComponent
            color={'primary'}
            style={{ width: '100%' }}
            onClick={onClickEnterIntoRemoteSellingButton(enterRemoteSelling)}
          >
            {' '}
            เข้าสู่การขายแบบ REMOTE SELLING{' '}
          </ButtonComponent>
        )}
      </>
    )
  }
}

const mapStateToEkycSellingChannel = (state: AppState, props) => {
  const app = getCurrentApp(state)
  const selectedRemoteSelling = app.selectedRemoteSelling
  const enableEkycOnDevice = isOnDeviceEKYC(app)
  const remoteSellingState = getRemoteSellingState(app)
  const isInCall = remoteSellingState.callStatus ? remoteSellingState.callStatus.isInCall : false
  const isPayerNeedToBeEkycDone = payerDoesEkyc(app)
  const isInsuredNeedToBeEkycDone = insurerDoesEkyc(app)
  const payerCitizenId = getCitizenId('payer')(app)
  let caseId = null

  if (remoteSellingState.ekyc) {
    caseId = remoteSellingState.ekyc.caseId
  }

  return {
    shouldShowF2fOption: checkShowingF2fOption(
      selectedRemoteSelling,
      isPayerNeedToBeEkycDone,
      isInsuredNeedToBeEkycDone,
      payerCitizenId
    ),
    selectedRemoteSelling,
    enableEkycOnDevice,
    isOpenNewRemoteSellingPreviewInfoModal: remoteSellingState.isOpenNewRemoteSellingPreviewInfoModal,
    isModalCreatingRemoteSellingOpen: remoteSellingState.isModalCreatingRemoteSellingOpen,
    creatingRemoteSellingCaseStatus: remoteSellingState.creatingRemoteSellingCaseStatus,
    isInCall,
    caseId,
  }
}

const mapDispatchToEkycSellingChannel = (dispatch: Dispatch<*>, props) => ({
  checkAppmanRemoteSelling: () => {
    dispatch(checkAppmanRemoteSelling())
  },
  uncheckAppmanRemoteSelling: () => {
    dispatch(uncheckAppmanRemoteSelling())
  },
  checkEkycOnDevice: () => {
    dispatch(enableEkycOnDevice())
  },
  uncheckEkycOnDevice: () => {
    dispatch(disabledEkycOnDevice())
  },
  enterRemoteSelling: () => {
    dispatch(enterRemoteSelling())
  },
  closeNewRemoteSellingPreviewInfoModal: () => {
    dispatch(closeNewRemoteSellingPreviewInfoModal())
  },
  closeCreatingRemoteSellingCaseModal: () => {
    dispatch(setAppValue(`remoteSelling.isModalCreatingRemoteSellingOpen`, false))
  },
  openNative: (caseId, nextProcess, push = true) => {
    dispatch(
      openNative({
        caseId,
        nextProcess,
        push,
      })
    )
  },
  closeSendingLinkModalRemoteSelling: () => {
    dispatch(closeSendingLinkModalRemoteSelling())
  },
  closeRemoteSellingResumeModal: () => {
    dispatch(closeRemoteSellingResumeModal())
  },
})

export default compose(
  connect(mapStateToEkycSellingChannel, mapDispatchToEkycSellingChannel),
  lifecycle({
    componentDidMount() {},
    componentDidUpdate(prevProps) {},
    componentWillReceiveProps(nextProps) {},
  })
)(EkycSellingChannel)
